import Vue from 'vue'
import Router from 'vue-router'
import RechnerTemplate from '@/components/rechner/Rechner_template'
import RechnerPage from '@/components/rechner/Rechner_Page'
import startPage from '@/components/rechner/Start_Page'
import stats from '@/components/tools/stats'
import page404 from '@/components/404'

import test from '@/components/tools/test'

Vue.use(Router)

export default new Router({
    mode: 'history',
    /******************************************************************
     * Query-Parameter:                                               *
     * ----------------                                               *
     * mode:        Darstellungs-modus, z.b. Headless                 *
     * tarifgruppe: wie z.B. o, n, i etc.                             *
     * multitarif:  single auswahl per Radio, oder multi per checkbox *
     *****************************************************************/
    routes: [
        {
            path: '/rechner',
            name: 'landing',
            component: startPage,
        },
        {
            path: '/rechner/vermittler/:vermittlerNr',
            name: 'landing_vermittler',
            component: startPage,
        },
        {
            path: '/rechner/:rechnerName',
            name: 'rechner',
            component: RechnerPage,
        },
        {
            path: '/rechner/:rechnerName/vermittler/:vermittlerNr',
            name: 'rechner_und_vermittler',
            component: RechnerPage,
        },
        /*
        {
            path: '/rechner/:rechnerName/filter/:tarifFilter',
            name: 'rechner_und_vermittler',
            component: RechnerPage,
        }, {
            path: '/rechner/:rechnerName/vermittler/:vermittlerNr/filter/:tarifFilter',
            name: 'rechner_und_vermittler',
            component: RechnerPage,
        },
        */


        {
            path: '/xxx',
            name: 'xxx',
            component: RechnerTemplate,
            children: [
                {
                    path: 'yyyy',
                    name: 'Wohngebäude',
                    component: RechnerPage
                }
            ]
        },
        {
            path: '/stats',
            name: 'stats',
            component: stats
        },
        {
            path: '/test',
            name: 'test',
            component: test
        },
        {
            path: '*',
            name: '404',
            component: page404
        }
    ]
})
